import { defineComponent as o, openBlock as n, createBlock as r, unref as m, mergeProps as i, withCtx as p, createElementVNode as s } from "vue";
import { RevIcon as h } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconListView1",
  __name: "IconListView1",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (c, e) => (n(), r(m(h), i(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        s("path", { d: "M5.25 5a.5.5 0 0 0-.5.5v2A.5.5 0 0 0 5.25 8h2a.5.5 0 0 0 .5-.5v-2A.5.5 0 0 0 7.25 5h-2m0 5.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2m-.5 6a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2m5-10.75a.75.75 0 0 0 0 1.5h8.75a.75.75 0 0 0 0-1.5H9.75M9 17.5a.75.75 0 0 1 .75-.75h8.75a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 17.5m.75-6.25a.75.75 0 0 0 0 1.5h8.75a.75.75 0 0 0 0-1.5H9.75" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
